import { render, staticRenderFns } from "./bbgl-alst.vue?vue&type=template&id=38364194&scoped=true"
import script from "./bbgl-alst.vue?vue&type=script&lang=js"
export * from "./bbgl-alst.vue?vue&type=script&lang=js"
import style0 from "./bbgl-alst.vue?vue&type=style&index=0&id=38364194&prod&lang=scss"
import style1 from "./bbgl-alst.vue?vue&type=style&index=1&id=38364194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38364194",
  null
  
)

export default component.exports